<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      :amzFirstDemandCode="amzFirstDemandCode"
    />
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
